import { render, staticRenderFns } from "./DecisionList.vue?vue&type=template&id=4f64c271&"
import script from "./DecisionList.vue?vue&type=script&lang=js&"
export * from "./DecisionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports